export default __webpack_public_path__ + "static/media/Night_01.057deb7e.png";